/* Code field (S-01): square boxes (information), the active one outlined in signal. */
.field {
  position: relative;
}
.boxes {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: var(--dimension-space-2);
}
.box {
  display: grid;
  place-items: center;
  height: 56px;
  background: var(--color-surface-raised);
  border: var(--dimension-line-hairline) solid var(--color-border-control);
  color: var(--color-text-primary);
}
.current {
  border: var(--dimension-line-control) solid var(--color-text-primary);
  outline: 3px solid var(--color-surface-signal);
}
.input {
  position: absolute;
  inset: 0;
  width: 100%;
  opacity: 0;
  caret-color: transparent;
  cursor: text;
}
